export default "__VITE_ASSET__CXqjFuHA__"